// extracted by mini-css-extract-plugin
export default {"chargeYourCustomers":"ChargeYourCustomers_chargeYourCustomers__dZN74","sectionTitle":"ChargeYourCustomers_sectionTitle__p6Tia","loading":"ChargeYourCustomers_loading__Xu6xb"};